export default {"src":"/_next/static/media/suppiler.f57fdc90.svg","height":120,"width":121};